import { FunctionComponent } from 'react';
import { Div, Headline, BodyText, Button } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

interface LoginFailedProps {}

const LoginFailed: FunctionComponent<LoginFailedProps> = () => {
  const { t } = useTranslation('authentication');
  const history = useHistory();

  const handleClick = (): void => {
    history.push('/authentication/login');
  };

  return (
    <Div padding={{ top: 'xxlg', horizontal: 'xxlg' }}>
      <Headline size="md" block>
        {t('LoginFailedComponent.title')}
      </Headline>
      <BodyText margin={{ top: 'xlg', bottom: 'sm' }} padding={{ top: 'md' }} fontWeight="bold" color="gray800">
        {t('LoginFailedComponent.subtitle')}
      </BodyText>
      <BodyText margin={{ bottom: 'xxlg' }} color="gray800">
        {t('LoginFailedComponent.content')}
      </BodyText>
      <Button variant="secondary" size="lg" onClick={handleClick}>
        {t('LoginFailedComponent.backButton')}
      </Button>
    </Div>
  );
};

export default LoginFailed;
